import AgiliteUtils from 'agilite-utils'

import MemoryStore from '../utils/memory-store'
import { cleanupObject, isDuplicateEntry, updateArrayDataFromSave } from '../utils/utilities'
import { postData } from '../core/core-utils'
import { formatRecord } from './template-utils'
import Enums from '../utils/enums'

/*
  ENUMS
*/
export const actions = {
  RESET_STATE: 'RESET_STATE_TEMPLATES',
  CREATE_PROFILE: 'CREATE_PROFILE_TEMPLATES',
  SAVE_PROFILE: 'SAVE_PROFILE_TEMPLATES',
  CANCEL_PROFILE: 'CANCEL_PROFILE_TEMPLATES',
  EDIT_PROFILE: 'EDIT_PROFILE_TEMPLATES',
  DELETE_PROFILE: 'DELETE_PROFILE_TEMPLATES',
  FETCH_ALL_DATA: 'FETCH_ALL_DATA_TEMPLATES',
  SET_SEARCH_FILTER: 'SET_SEARCH_FILTER_TEMPLATES',
  UPDATE_DATA: 'UPDATE_DATA_TEMPLATES'
}

/*
  DISPATCH FUNCTIONS
*/
export const setSearchFilter = (value) => {
  return {
    type: actions.SET_SEARCH_FILTER,
    value
  }
}

export const updateData = (data) => {
  return {
    type: actions.UPDATE_DATA,
    data
  }
}

export const saveProfile = (appId, recordId, state, callback) => {
  return async (dispatch) => {
    const entry = MemoryStore.activeEntries[recordId]
    const headers = {}

    let result = true
    let reqType = ''
    let tempArray = state.data.concat()
    let errorMsg = null

    // Cleanup and Trim
    cleanupObject(entry.data)
    await AgiliteUtils.trimObjectValues(entry.data)

    // Validation
    if (entry.data.key === '') {
      errorMsg = 'Please provide a Profile Key'
      return callback(errorMsg)
    }

    // Duplicate Check
    result = isDuplicateEntry(entry, 'key', tempArray, true)

    if (!result) {
      errorMsg = `Profile Key '${entry.data.key}' is already being used`
      return callback(errorMsg)
    }

    // To, cc, bcc fields validation
    if (entry.data.templateType === 'memo') {
      if (entry.data.sendTo === '' && entry.data.copyTo === '' && entry.data.blindCopyTo === '') {
        errorMsg = 'At least one of Send To, Copy To or Blind Copy To needs to contain a value'
        return callback(errorMsg)
      }
    }

    // Finalize

    // Post Data to Agilit-e
    tempArray = formatRecord(entry, tempArray)
    reqType = entry.custom.action === 'create' ? 'post' : 'put'

    // Create Headers Object
    headers['record-id'] = recordId

    postData(appId, reqType, entry, headers)
      .then((response) => {
        callback(null)

        entry.custom.action = ''
        entry.custom.isSavedDoc = true
        entry.key = response.data._id
        entry._id = response.data._id
        entry.data.isActiveDescription = response.data.data.isActive ? 'Yes' : 'No'

        // Dispatch New Array
        tempArray = updateArrayDataFromSave(entry, tempArray)
        dispatch({ type: actions.UPDATE_DATA, data: tempArray })
      })
      .catch((error) => {
        console.log(error)

        if (error.response) {
          callback(error.response.data.errorMessage)
        } else {
          callback(Enums.MESSAGES.UNKNOWN_ERROR)
        }
      })
  }
}
